import { useIsEditorApp } from "@core-ui/hooks/useIsEditorApp";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { type ReactElement, useState } from "react";
import { useAgentChatPanel } from "./hooks/useAgentChatPanel";
import { useAgentChatHealthcheck } from "./store/AgentChatHealthcheckStore";

const AgentChatPanelController = (): null => {
	useAgentChatPanel();
	return null;
};

const usePortalAgentAvailable = (): boolean => {
	const { isNext } = usePlatform();
	const { status } = useAgentChatHealthcheck();
	const [wasAvailable, setWasAvailable] = useState(false);

	if (status === "available" && !wasAvailable) setWasAvailable(true);
	if (status === "unavailable" && wasAvailable) setWasAvailable(false);

	return isNext && (status === "available" || (status === "checking" && wasAvailable));
};

const AgentChatSessions = (): ReactElement => {
	const isEditorApp = useIsEditorApp();
	const isPortalAgentAvailable = usePortalAgentAvailable();
	return isEditorApp || isPortalAgentAvailable ? <AgentChatPanelController /> : null;
};

const AgentChatService = {
	Init: (): ReactElement => <AgentChatSessions />,
};

export default AgentChatService;
